import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revolution-slider6',
  templateUrl: './revolution-slider6.component.html'
})
export class RevolutionSlider6Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
